import { CircularProgress } from '@mui/material';
import Button from 'js/components/elements/editors/mui/Button';
import { FileWithPreview } from 'js/components/data_sources/add_ds_form/FileUploadConfiguration/FileUploadConfiguration.types';
import React from 'react';
import { CodeSection, StatusMessage } from 'new/components/flows/shared/customProcessor';
import classes from 'new/components/flows/shared/customProcessor/TestCustomProcessor.module.scss';
import UploadedFileSelector from './UploadedFileSelector';

interface Props {
  uploadedFiles: FileWithPreview[];
  path: string;
  onPathChanged: (value: string) => void;
  isLoading: boolean;
  onTest: () => void;
  statusMessage: string | null;
  showParserOutput: boolean;
  sourceConfig: any;
  parserOutput: any;
  testResult: any;
  isLoadingParserOutput: boolean;
  isLoadingTestResult: boolean;
}

export default function FileUploadTestPanel({
  uploadedFiles,
  path,
  onPathChanged,
  isLoading,
  onTest,
  statusMessage,
  showParserOutput,
  sourceConfig,
  parserOutput,
  testResult,
  isLoadingParserOutput,
  isLoadingTestResult,
}: Props) {
  return (
    <div className={classes.inputSourceBlock}>
      <div className={classes.testToolbar}>
        <UploadedFileSelector files={uploadedFiles} path={path} onChange={onPathChanged} />
        <Button
          className={classes.testButton}
          variant="ghost"
          color="secondary"
          disabled={isLoading || !path}
          onClick={onTest}
          data-testid="test-custom-processor-button"
        >
          {isLoading ? <CircularProgress size={20} /> : 'Run Test'}
        </Button>
      </div>
      <div className={classes.bottom}>
        {showParserOutput && (
          <CodeSection
            heading="Nexla Parser Output"
            subheading={sourceConfig?.advanced_settings ?? ''}
            isLoading={isLoadingParserOutput}
            result={parserOutput}
            editorHeight="325px"
            data-testid="nexla-parser-output"
          />
        )}
        <CodeSection
          heading="Custom Post Processor Output"
          subheading={path || '(No file selected)'}
          isLoading={isLoadingTestResult}
          result={testResult}
          editorHeight="325px"
          data-testid="custom-post-processor-output"
        />
      </div>
      {statusMessage && <StatusMessage message={statusMessage} />}
    </div>
  );
}
